export function convertUrlNotifications(route: string): string {
  const typeARegex = /^\/client-panel\/register\/macroprocess\/(?<processType>[^/]+)\/(?<schemeId>[^/]+)\/response\/(?<responseId>[^/]+)(?<tail>\/.*)?$/;
  const typeCRegex = /^\/client-panel\/(?<processType>[^/]+)\/(?<schemeId>[^/]+)\/response\/(?<responseId>[^/]+)(?<tail>\/.*)?$/;
  const typeERegex = /^\/client-panel\/ct\/(?<schemeId>[^/]+)\/response\/(?<responseId>[^/]+)(?<tail>\/.*)?$/;
  const typeBRegex = /^\/panel\/schemes\/(?<processType>[^/]+)\/(?<stepType>[^/]+)\/(?<backType>[^/]+)\/(?<groupId>[^/]+)\/response\/(?<responseId>[^/]+)(?<tail>\/.*)?$/;
  const typeDRegex = /\/panel\/schemes\/ct\/(?<schemeId>[^/]+)\/(?:[^/]*)\/(?:[^/]*)\/response\/(?<responseId>[^/]+)(?<tail>\/.*)?/;

  function normalizeTail(tail?: string) {
    if (!tail) return [];
    return tail.split('/').filter(s => s !== '');
  }

  // normalize route: remove origin, keep part after '#' if present
  // if there's a `route` query param (ex: /login?route=/client-panel/...), use it
  let path = route;
  const hashIndex = path.indexOf('#');
  if (hashIndex !== -1) path = path.slice(hashIndex + 1);
  const queryIndex = path.indexOf('?');
  if (queryIndex !== -1) {
    const query = path.slice(queryIndex + 1);
    const routeParamMatch = query.match(/(?:^|&)route=([^&]+)/);
    if (routeParamMatch) {
      try {
        path = decodeURIComponent(routeParamMatch[1]);
      } catch (e) {
        path = routeParamMatch[1];
      }
    } else {
      // no `route` param: strip query string
      path = path.slice(0, queryIndex);
    }
  }
  if (!path.startsWith('/')) path = '/' + path;

  // type A: /client-panel/register/macroprocess/... -> /panel/schemes/...
  let match = path.match(typeARegex);
  if (match?.groups) {
    const { processType, schemeId, responseId, tail } = match.groups;
    const tailSegments = normalizeTail(tail);
    const stepType = 'null';
    const backType = 'null';
    const groupId = schemeId;
    let base = `/panel/schemes/${processType}/${stepType}/${backType}/${groupId}/response/${responseId}`;
    if (tailSegments.length) base += `/${tailSegments.join('/')}`;
    return base;
  }

  // type D: panel/schemes/ct/:schemeId/.../response/:responseId -> client-panel/ct/:schemeId/response/:responseId
  // check this more specific CT pattern before the more generic type B
  const matchD = path.match(typeDRegex);
  if (matchD?.groups) {
    const { schemeId, responseId, tail } = matchD.groups;
    const tailSegments = normalizeTail(tail);
    let base = `/client-panel/ct/${schemeId}/response/${responseId}`;
    if (tailSegments.length) base += `/${tailSegments.join('/')}`;
    return base;
  }

  // type B: /panel/schemes/... -> client-panel or client-panel/register depending on processType
  match = path.match(typeBRegex);
  if (match?.groups) {
    const { processType, groupId, responseId, tail } = match.groups;
    const tailSegments = normalizeTail(tail);
    if (processType === 'ct') {
      let base = `/client-panel/${processType}/${groupId}/response/${responseId}`;
      if (tailSegments.length) base += `/${tailSegments.join('/')}`;
      return base;
    } else {
      let base = `/client-panel/register/macroprocess/${processType}/${groupId}/response/${responseId}`;
      if (tailSegments.length) base += `/${tailSegments.join('/')}`;
      return base;
    }
  }

  // type E: /client-panel/ct/:schemeId/response/:responseId -> panel/schemes/ct/null/null/:schemeId/response/:responseId
  const matchE = path.match(typeERegex);
  if (matchE?.groups) {
    const { schemeId, responseId, tail } = matchE.groups;
    const tailSegments = normalizeTail(tail);
    let base = `/panel/schemes/ct/${schemeId}/null/null/response/${responseId}`;
    if (tailSegments.length) base += `/${tailSegments.join('/')}`;
    return base;
  }

  // type C: /client-panel/:processType/:schemeId/response/:responseId -> panel/schemes/...
  match = path.match(typeCRegex);
  if (match?.groups) {
    const { processType, schemeId, responseId, tail } = match.groups;
    const tailSegments = normalizeTail(tail);
    const stepType = 'null';
    const backType = 'null';
    const groupId = schemeId;
    let base = `/panel/schemes/${processType}/${stepType}/${backType}/${groupId}/response/${responseId}`;
    if (tailSegments.length) base += `/${tailSegments.join('/')}`;
    return base;
  }

  return '';
}
